import React, { useState } from 'react';

const ProjectMultiSelect = ({ projects, onChange }) => {
  const [selected, setSelected] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const isAllSelected = selected.length === projects.length;

  const toggleProject = (project) => {
    setSelected(prev => {
      const exists = prev.find(p => p.id === project.id);
      const next = exists ? prev.filter(p => p.id !== project.id) : [...prev, project];
      if (onChange) onChange(next);
      return next;
    });
  };

  const toggleSelectAll = () => {
    const next = isAllSelected ? [] : [...projects];
    setSelected(next);
    if (onChange) onChange(next);
  };

  const isSelected = (id) => selected.some(p => p.id === id);

  return (
    <div style={{ position: 'absolute', top: 60, right: 100, fontSize: 20 }}>
      <button
        onClick={() => setIsOpen(prev => !prev)}
        style={{ width: '100%', padding: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        {selected.length === 0 ? "Seleccionar proyectos" : `${selected.length} seleccionados`}
        <span style={{ marginLeft: '8px' }}>▼</span>
      </button>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '200px',
            backgroundColor: 'rgb(23,23,23);',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,

          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontSize: '16px' }}>
            <input
              type="checkbox"
              id="select-all"
              checked={isAllSelected}
              onChange={toggleSelectAll}
            />
            <label htmlFor="select-all" style={{ fontSize: '16px' }}>Seleccionar todos</label>
          </div>
          <div style={{ maxHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {projects.map(project => (
              <div key={project.id} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  id={project.id}
                  checked={isSelected(project.id)}
                  onChange={() => toggleProject(project)}
                />
                <label htmlFor={project.id} style={{ fontSize: '16px' }}>{project.name}</label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectMultiSelect;


